/* Tilda-style клиентская валидация для лид-форм лендингов.
 *
 * Подключение к форме: добавить класс `js-tilda-form`. Модуль на DOMContentLoaded
 * сам найдёт все такие формы и навесит обработчики.
 *
 * Правила читаются из атрибутов инпутов:
 *   • required          → нативный HTML5 `required` (simple_form: `required: true`)
 *   • email-format      → `type="email"` (simple_form: `as: :email`)
 *   • phone-format      → `type="tel"` (simple_form: `as: :tel`)
 *   • name-format       → `data-validate="name"` на инпуте (нет нативного аналога)
 *
 * Текcты ошибок и regex'ы скопированы 1 в 1 из tilda-forms-1.0.min.js
 * (см. tasks/dumps/baza.education/js/tilda-forms-1.0.min.js, t_forms__validate
 * + словарь t_forms__getMsg.e.RU). Phone-regex упрощён до whitelist'а
 * [0-9 + - ( ) пробел] — без Tilda anti-spam-последовательностей.
 *
 * UX: на submit показываются ошибки в `.field_with_errors` + `<span class="error">`
 * (mirrors simple_form server-side markup), скролл + focus к первому invalid'у.
 * Кнопка submit'а никогда не блокируется. Live-clear: ввод в ошибочное поле
 * мгновенно убирает с него подсветку. */

(function () {
  'use strict';

  // RU dictionary — t_forms__getMsg, e.RU
  var MSG = {
    reqfield: 'Обязательное поле',
    email: 'Укажите, пожалуйста, корректный email',
    phone: 'Укажите, пожалуйста, корректный номер телефона',
    name: 'Укажите, пожалуйста, имя'
  };

  // Tilda email regex — case 'email'. Флаг /g снят: используем .test()
  // и не хотим состояния lastIndex между вызовами.
  var RE_EMAIL = /^(?!\.)(?!.*\.\.)[a-zA-Zёа-яЁА-Я0-9⺀-⿕㆐-㆟㐀-䶿一-鿌豈-﫿_\.\-\+]{0,63}[a-zA-Zёа-яЁА-Я0-9⺀-⿕㆐-㆟㐀-䶿一-鿌豈-﫿_\-\+]@[a-zA-Zёа-яЁА-ЯЁёäöüÄÖÜßèéû0-9][a-zA-Zёа-яЁА-ЯЁёäöüÄÖÜßèéû0-9\.\-]{0,253}\.[a-zA-Zёа-яЁА-Я]{2,11}$/i;

  // Tilda name regex — case 'name'. Флаг /g снят. Покрывает буквы из
  // ~30 алфавитов (lat/cyrillic/CJK/diacritics), цифры запрещены.
  var RE_NAME = /^([ЁёäöüÄÖÜßèéûҐґЄєІіЇїӐӑЙйК̆к̆Ӄ̆ӄ̆Ԛ̆ԛ̆Г̆г̆Ҕ̆ҕ̆ӖӗѢ̆ѣ̆ӁӂꚄ̆ꚅ̆ҊҋО̆о̆Ө̆ө̆Ꚍ̆ꚍ̆ЎўХ̆х̆Џ̆џ̆Ꚏ̆ꚏ̆Ꚇ̆ꚇ̆Ҽ̆ҽ̆Ш̆ш̆Ꚗ̆ꚗ̆Щ̆щ̆Ы̆ы̆Э̆э̆Ю̆ю̆Я̆я̆А́а́ЃѓД́д́Е́е́Ё́ёӘ́ә́З́з́И́и́І́і́Ї́ї́ЌќЛ́л́Н́н́О́о́Р́р́С́с́Т́т́У́у́Ӱ́ӱ́Ү́ү́Х́х́Ц́ц́Ы́ы́Э́э́Ӭ́ӭ́Ю́ю́Ю̈́ю̈́Я́я́Ѣ́ѣ́ҒғӺӻҒ̌ғ̌Ј̵ј̵ҞҟҜҝԞԟӨөҎҏҰұӾӿҸҹҌҍҢңҚқҒғӘәҺһІіҰұҮүӨөȺⱥꜺꜻƂƃɃƀȻȼꞒꞓƋƌĐđɆɇǤǥꞠꞡĦħƗɨƗ́ɨ́Ɨ̀ɨ̀Ɨ̂ɨ̂Ɨ̌ɨ̌Ɨ̃ɨ̃Ɨ̄ɨ̄Ɨ̈ɨ̈Ɨ̋ɨ̋Ɨ̏ɨ̏Ɨ̧ɨ̧Ɨ̧̀ɨ̧̀Ɨ̧̂ɨ̧̂Ɨ̧̌ɨ̧̌ᵼɈɉɟɟ̟ʄʄ̊ʄ̥K̵k̵ꝀꝁꝂꝃꝄꝅꞢꞣŁłł̓Ł̣ł̣ᴌȽƚⱠⱡꝈꝉƛƛ̓ꞤꞥꝊꝋØøǾǿØ̀ø̀Ø̂øØ̌ø̌Ø̄ø̄Ø̃ø̃Ø̨ø̨Ø᷎ø᷎ᴓⱣᵽꝐꝑꝖꝗꝘꝙɌɍꞦꞧꞨꞩẜẝŦŧȾⱦᵺꝤꝥꝦꝧɄʉɄ́ʉ́Ʉ̀ʉ̀Ʉ̂ʉ̂Ʉ̌ʉ̌Ʉ̄ʉ̄Ʉ̃ʉ̃Ʉ̃́ʉ̃́Ʉ̈ʉ̈ʉ̞ᵾU̸u̸ᵿꝞꝟw̸ɎɏƵƶA-Za-zÀÀ-ÃÈ-ÊÌÍÒ-ÙÚÝà-ãèéêìíò-õùúýĂăĐđĨĩŨũƠơƯưẠạ-ỹ'’̀-ϿЀ-ӿԀ-׿؀-ۿ぀-ヿA-zÀ-ʸיִ-ײַשׁ-פֿ฀-๿Ⴀ-ჿ぀-ゟ゠-ヿ⺀-⿕㆐-㆟㐀-䶿一-鿌豈-﫿]{1,})([ЁёäöüÄÖÜßèéûҐґЄєІіЇїӐӑЙйК̆к̆Ӄ̆ӄ̆Ԛ̆ԛ̆Г̆г̆Ҕ̆ҕ̆ӖӗѢ̆ѣ̆ӁӂꚄ̆ꚅ̆ҊҋО̆о̆Ө̆ө̆Ꚍ̆ꚍ̆ЎўХ̆х̆Џ̆џ̆Ꚏ̆ꚏ̆Ꚇ̆ꚇ̆Ҽ̆ҽ̆Ш̆ш̆Ꚗ̆ꚗ̆Щ̆щ̆Ы̆ы̆Э̆э̆Ю̆ю̆Я̆я̆А́а́ЃѓД́д́Е́е́Ё́ёӘ́ә́З́з́И́и́І́і́Ї́ї́ЌќЛ́л́Н́н́О́о́Р́р́С́с́Т́т́У́у́Ӱ́ӱ́Ү́ү́Х́х́Ц́ц́Ы́ы́Э́э́Ӭ́ӭ́Ю́ю́Ю̈́ю̈́Я́я́Ѣ́ѣ́ҒғӺӻҒ̌ғ̌Ј̵ј̵ҞҟҜҝԞԟӨөҎҏҰұӾӿҸҹҌҍҢңҚқҒғӘәҺһІіҰұҮүӨөȺⱥꜺꜻƂƃɃƀȻȼꞒꞓƋƌĐđɆɇǤǥꞠꞡĦħƗɨƗ́ɨ́Ɨ̀ɨ̀Ɨ̂ɨ̂Ɨ̌ɨ̌Ɨ̃ɨ̃Ɨ̄ɨ̄Ɨ̈ɨ̈Ɨ̋ɨ̋Ɨ̏ɨ̏Ɨ̧ɨ̧Ɨ̧̀ɨ̧̀Ɨ̧̂ɨ̧̂Ɨ̧̌ɨ̧̌ᵼɈɉɟɟ̟ʄʄ̊ʄ̥K̵k̵ꝀꝁꝂꝃꝄꝅꞢꞣŁłł̓Ł̣ł̣ᴌȽƚⱠⱡꝈꝉƛƛ̓ꞤꞥꝊꝋØøǾǿØ̀ø̀Ø̂øØ̌ø̌Ø̄ø̄Ø̃ø̃Ø̨ø̨Ø᷎ø᷎ᴓⱣᵽꝐꝑꝖꝗꝘꝙɌɍꞦꞧꞨꞩẜẝŦŧȾⱦᵺꝤꝥꝦꝧɄʉɄ́ʉ́Ʉ̀ʉ̀Ʉ̂ʉ̂Ʉ̌ʉ̌Ʉ̄ʉ̄Ʉ̃ʉ̃Ʉ̃́ʉ̃́Ʉ̈ʉ̈ʉ̞ᵾU̸u̸ᵿꝞꝟw̸ɎɏƵƶA-Za-zÀÀ-ÃÈ-ÊÌÍÒ-ÙÚÝà-ãèéêìíò-õùúýĂăĐđĨĩŨũƠơƯưẠạ-ỹA-zÀ-ʸ̀-ϿЀ-ӿԀ-׿؀-ۿ぀-ヿיִ-ײַשׁ-פֿ฀-๿Ⴀ-ჿ぀-ゟ゠-ヿ⺀-⿕㆐-㆟㐀-䶿一-鿌豈-﫿\-\'‘ʼ\s\.]{0,})$/i;

  // Phone whitelist (упрощённый — без Tilda anti-spam-последовательностей).
  var RE_PHONE = /^[0-9+\-() ]+$/;

  // Типы инпутов, которые не валидируем (служебные).
  var SKIP_INPUT_TYPES = ['submit', 'button', 'reset', 'hidden', 'image', 'file'];

  function isValidatable(el) {
    if (el.tagName === 'INPUT') {
      var t = (el.type || '').toLowerCase();
      if (SKIP_INPUT_TYPES.indexOf(t) !== -1) return false;
    }
    return true;
  }

  function getValidatableFields(form) {
    var nodes = form.querySelectorAll('input, textarea, select');
    var out = [];
    Array.prototype.forEach.call(nodes, function (el) {
      if (isValidatable(el)) out.push(el);
    });
    return out;
  }

  function getFieldType(input) {
    var t = (input.type || '').toLowerCase();
    if (t === 'email') return 'email';
    if (t === 'tel') return 'phone';
    var v = (input.dataset && input.dataset.validate) || '';
    if ((' ' + v + ' ').indexOf(' name ') !== -1) return 'name';
    return null;
  }

  function getWrapper(input) {
    return input.closest('.input') || input.parentNode;
  }

  function showFieldError(input, msg) {
    var wrap = getWrapper(input);
    wrap.classList.add('field_with_errors');
    var existing = wrap.querySelector('span.error');
    if (existing) {
      existing.textContent = msg;
      return;
    }
    var span = document.createElement('span');
    span.className = 'error';
    span.textContent = msg;
    wrap.appendChild(span);
  }

  function hideFieldError(input) {
    var wrap = getWrapper(input);
    wrap.classList.remove('field_with_errors');
    var err = wrap.querySelector('span.error');
    if (err && err.parentNode) err.parentNode.removeChild(err);
  }

  function validateField(input) {
    var v = (input.value || '').trim();
    if (input.required && !v) return MSG.reqfield;
    if (!v) return null;
    var type = getFieldType(input);
    if (type === 'email' && !RE_EMAIL.test(v)) return MSG.email;
    if (type === 'name' && !RE_NAME.test(v)) return MSG.name;
    if (type === 'phone' && !RE_PHONE.test(v)) return MSG.phone;
    return null;
  }

  function validateForm(form) {
    var errors = [];
    getValidatableFields(form).forEach(function (input) {
      var msg = validateField(input);
      if (msg) errors.push({ input: input, msg: msg });
    });
    return errors;
  }

  function clearAllErrors(form) {
    Array.prototype.forEach.call(
      form.querySelectorAll('.field_with_errors'),
      function (w) { w.classList.remove('field_with_errors'); }
    );
    Array.prototype.forEach.call(
      form.querySelectorAll('span.error'),
      function (e) { if (e.parentNode) e.parentNode.removeChild(e); }
    );
  }

  function bindLiveClear(form) {
    getValidatableFields(form).forEach(function (input) {
      input.addEventListener('input', function () {
        if (getWrapper(input).classList.contains('field_with_errors')) {
          hideFieldError(input);
        }
      });
    });
  }

  function initForm(form) {
    form.addEventListener('submit', function (e) {
      clearAllErrors(form);
      var errors = validateForm(form);
      if (!errors.length) return;
      e.preventDefault();
      errors.forEach(function (err) { showFieldError(err.input, err.msg); });
      var first = errors[0].input;
      if (first.scrollIntoView) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      first.focus();
    });

    bindLiveClear(form);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('form.js-tilda-form'),
      initForm
    );
  });
})();
